<script setup lang="ts">

import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { useShipDesignCreationStore } from '@/stores/shipDesignCreationStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Stores / models
 */
const shipDesignCreationStore = useShipDesignCreationStore()

</script>

<template>
  <StandardCard :title="t('modals.shipDesignHelp.howToDesign')" top-padding="0">
    <p class="pb-2">{{ t('modals.shipDesignHelp.step1') }} <GenericIcon :tooltip="t('modals.shipDesignHelp.tooltips.shipFrame')" type="frame"/> <GenericIcon type="mass"/></p>
  </StandardCard>
  <StandardCard>
    <p class="pb-2">{{ t('modals.shipDesignHelp.step2a') }} <GenericIcon :tooltip="t('modals.shipDesignHelp.tooltips.engineSpeed')" type="max_speed"/> <GenericIcon :tooltip="t('modals.shipDesignHelp.tooltips.engineThrust')" type="thrust"/></p>
    <p class="pb-2">{{ t('modals.shipDesignHelp.step2b') }}</p>
    <p>{{ t('modals.shipDesignHelp.step2c') }}</p>
  </StandardCard>
  <StandardCard>
    <p>{{ t('modals.shipDesignHelp.step3') }} <GenericIcon :tooltip="t('modals.shipDesignHelp.tooltips.productionCost')" type="production"/></p>
  </StandardCard>
  <StandardCard>
    <p>{{ t('modals.shipDesignHelp.step4') }}</p>
  </StandardCard>
  <StandardCard>
    <div class="flex justify-center">
      <ActionButton @click="shipDesignCreationStore.createModalTab = 'add'">{{ t('command.ships.letsStartDesigning') }}</ActionButton>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>